
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class LhcWinTable extends Vue {
    //六合彩中间
    table = {
        data: [],
        column: [
            {
                key: 'qihao',
                title: '期号',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).qihao
                    return h('span', str)
                }
            },
            {
                key: 'status',
                title: '订单状态',
                align: 'center',
                render: (h, params) => {
                    let arr = ['待派奖', '中奖', '未中奖', '不派奖']
                    let str = arr[JSON.parse(params.row.opt_detail).status - 1]
                    return h('span', str)
                }
            },
            {
                key: 'orderid',
                title: '订单号',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).orderid
                    return h('span', str)
                }
            },
            {
                key: 'tz_count',
                title: '投注总注数',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).tz_count
                    return h('span', str)
                }
            },
            {
                key: 'tz_point',
                title: '投注总金额',
                align: 'center',
                render: (h, params) => {
                    let str = (this as any).getMoney(JSON.parse(params.row.opt_detail).tz_point)
                    return h('span', str)
                }
            },
            {
                key: 'hit_point',
                title: '返奖总金额',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).hit_point) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).hit_point)
                    }
                    return h('span', str)
                }
            },
            {
                key: 'hit_time',
                title: '派奖时间',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).hit_time
                    return h('span', str)
                }
            },
            {
                key: 'subType',
                title: '投注方式',
                align: 'center',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let str = this.subgamename(JSON.parse(obj)[0].subType)
                    return h('span', str)
                }
            },
            {
                key: 'tzhm',
                title: '投注号码',
                align: 'center',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let str = JSON.parse(obj)[0].tzhm
                    return h('span', str)
                }
            },
            {
                key: 'tzhm',
                title: '赔率',
                align: 'center',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let str = JSON.parse(obj)[0].odds['1']
                    return h('span', str)
                }
            },
            {
                title: '开奖结果',
                key: 'kjhm',
                align: 'center',
                width: '280px',
                render: (h, params) => {
                    let obj = JSON.parse(params.row.opt_detail).tz_info
                    let kjhm = JSON.parse(obj)[0].kjhm
                    let kj_ext = JSON.parse(obj)[0].kjExt
                    let arr = []
                    let list = kjhm.split(',')
                    list.splice(6, 0, '+')
                    let kjext = kj_ext.split(',')
                    kjext.splice(6, 0, '+')
                    return h('div', [
                        h(
                            'div',
                            {
                                style: {
                                    margin: '5px'
                                }
                            },
                            list.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        display: 'inline-block',
                                        width: '25px',
                                        background: this.bgcbo(v),
                                        height: '25px',
                                        borderRadius: '50%',
                                        textAlign: 'center',
                                        marginLeft: '5px',
                                        color: index == 6 ? '#333' : '#fff',
                                        fontSize: index == 6 ? '18px' : '14px',
                                        lineHeight: '27.5px'
                                    },
                                    domProps: {
                                        innerHTML: v
                                    }
                                })
                            })
                        ),
                        h(
                            'div',
                            {
                                style: {
                                    margin: '5px'
                                }
                            },
                            kjext.map((v, index) => {
                                // 遍历后台params.row.manager_list
                                return h('div', {
                                    style: {
                                        display: 'inline-block',
                                        width: '25px',
                                        background: index == 6 ? '' : '#FF9033',
                                        height: '15px',
                                        textAlign: 'center',
                                        marginLeft: '5px',
                                        color: index == 6 ? '#333' : '#fff',
                                        fontSize: index == 6 ? '18px' : '12px',
                                        lineHeight: '17.5px'
                                    },
                                    domProps: {
                                        innerHTML: this.kjext(v)
                                    }
                                })
                            })
                        )
                    ])
                }
            }
        ]
    }
    //六合彩子玩法
    subgamename(num) {
        let arr = ['特码直选', '两面', '正码任选', '正1特', '正1两面', '正2特', '正2两面', '正3特', '正3两面', '正4特', '正4两面', '正5特', '正5两面', '正6特', '正6两面', '三全中', '三中二', '二全中', '二中特', '特串', '特码半波', '特肖', '一肖', '二连肖', '三连肖', '四连肖', '总肖', '正肖', '合肖中', '合肖不中', '特码头尾', '二连尾', '三连尾', '四连尾', '五不中', '六不中', '七不中', '八不中', '九不中', '十不中', '七色波']
        return arr[num - 1]
    }
    //开奖动物属性
    kjext(num) {
        let arr = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪']
        return arr[num - 1]
    }
    //开奖数字的颜色
    bgcbo(num) {
        let redbo = ['01', '02', '07', '08', '12', '13', '18', '19', '23', '24', '29', '30', '34', '35', '40', '45', '46']
        let bluebo = ['03', '04', '09', '10', '14', '15', '20', '25', '26', '31', '36', '37', '41', '42', '47', '48']
        let greenbo = ['05', '06', '11', '16', '17', '21', '22', '27', '28', '32', '33', '38', '39', '43', '44', '49']
        if (redbo.indexOf(num) > -1) {
            return 'red'
        } else if (bluebo.indexOf(num) > -1) {
            return 'blue'
        } else if (greenbo.indexOf(num) > -1) {
            return 'green'
        }
    }

    @Prop()
    listdata
}
